






























import Vue from 'vue'
import Component from 'vue-class-component'
import { Injector } from '@/config/dependency-injection'
import { MessageModule } from '@/business/message/store/message-module'
import { Contact } from '@/business/message/models/contact'
import ContactItem from '@/business/message/components/contact-item.vue'
import IncomingMessage from '@/business/message/components/incoming-message.vue'
import NewMessage from '@/business/message/components/new-message.vue'
import RespondecoOrganisationSelect from '@/shared/components/respondeco-organisation-select.vue'
import ContactList from '@/business/message/components/contact-list.vue'
import EmptyChatArea from '@/business/message/components/empty-chat-area.vue'
import ChatArea from '@/business/message/components/chat-area.vue'
import { Focusable } from '@/shared/interfaces/focusable'
import { CLEAR_INBOX, FETCH_MESSAGES } from '@/business/message/store/types'
import { LoaderHelper } from '@/shared/services/loader-helper'
import { Route, VueRouter } from 'vue-router/types/router'
import { RouterToken } from '@/config/injection-tokens'
import { SharedModule } from '@/shared/store/shared-module'
import UnifyHero from '@/shared/components/unify/unify-hero.vue'
import RespondecoLoadingIndicator from '@/shared/components/respondeco-loading-indicator.vue'
import { RouterNextFunction } from '@/shared/interfaces/router-next-function'
import { Hooks } from '@/shared/interfaces/hooks'
import { MetaService } from '@/shared/services/meta-service'
import { noop } from '@/shared/utils/noop'

@Component({
  components: {
    RespondecoLoadingIndicator,
    UnifyHero,
    ChatArea,
    EmptyChatArea,
    ContactList,
    RespondecoOrganisationSelect,
    NewMessage,
    IncomingMessage,
    ContactItem,
  },
  data() {
    return {
      selectedContact: undefined,
    }
  },
})
export default class Inbox extends Vue implements Hooks {
  get contactMap() {
    return this.messageModule.data.inbox.contactMap
  }

  get contacts() {
    return this.messageModule.data.inbox.contacts
  }

  get loading() {
    return this.loaderHelper.isLoading(FETCH_MESSAGES)
  }

  public selectedContact?: Contact

  private initialised = false
  private loaderHelper = Injector.get(LoaderHelper)
  private messageModule = Injector.get(MessageModule)
  private metaService = Injector.get(MetaService)
  private router: VueRouter = Injector.get<VueRouter>(RouterToken)
  private sharedModule: SharedModule = Injector.get(SharedModule)

  public beforeDestroy() {
    this.messageModule[CLEAR_INBOX]()
  }

  public beforeRouteUpdate(to: Route, from: Route, next: RouterNextFunction) {
    this.showContact(Number(to.params.organisation))

    next()
  }

  public mounted() {
    this.messageModule
      .fetchMessages()
      .then(() => {
        this.showContact(Number(this.router.currentRoute.params.organisation))

        this.initialised = true
      })
      .catch(noop)

    this.metaService.updateDocumentTitle('inbox')

    this.$watch(
      () => this.messageModule.data.inbox.contacts.length,
      () => {
        this.showContact(Number(this.router.currentRoute.params.organisation))
      }
    )
  }

  public showContact(contactOrId: Contact | number) {
    let contact: Contact | undefined

    if (typeof contactOrId === 'number') {
      contact = this.contactFromId(contactOrId)
    } else {
      contact = contactOrId
    }

    this.selectedContact = contact

    if (this.initialised) {
      setTimeout(() => {
        if (contact === undefined) {
          const emptyChatArea: Focusable = this.$refs.emptyChatArea as any

          emptyChatArea.focus()
        } else {
          // TODO evaluate if focus should be set automatically
          // const chatArea: Focusable = this.$refs.chatArea as any
          //
          // chatArea.focus()
        }
      }, 0)
    }
  }

  private contactFromId(organisationId: number): Contact | undefined {
    let contact: Contact | undefined

    if (organisationId !== undefined) {
      if (this.contactMap[organisationId] !== undefined) {
        contact = this.contactMap[organisationId]
      } else {
        const organisation = this.sharedModule.data.organisationMap[organisationId]

        if (organisation !== undefined) {
          contact = {
            id: organisation.id,
            image: organisation.image,
            lastContact: new Date(),
            lastMessage: '',
            messages: [],
            name: organisation.name,
            numberOfMessages: 0,
          }
        }
      }
    }

    return contact
  }
}
